export default __webpack_public_path__ + "static/media/bg-mudan.c8a7a57e.png";